import { mapState } from 'vuex';
import { INIT_WELFARE_BTN } from '@store/officialWebStore/index';

export default {
  computed: {
    ...mapState({
      gameId: state => state.gameId,
      hasLoadPaytype: state => state.hasLoadPaytype,
      isLogin: state => state.login.isLogin,
      boolInitWelfareBtnRecord: state => state.boolInitWelfareBtnRecord
    })
  },
  methods: {
    initWelfareBtn() {
      if (this.boolInitWelfareBtnRecord) {
        return;
      }
      const recordBtnArr = [];
      this.$store.commit(INIT_WELFARE_BTN, recordBtnArr);
    }
  },
  created() {
    this.initWelfareBtn();
  }
};
